import axios from '@/plugins/axiosInstance'
import { socialMedia } from '@/networking/urlManager'

/**
 * Check social media authentication status
 * @param {string} assetId - Asset ID
 * @returns {Promise<Object>} Object containing auth status for different platforms
 */
export const checkSocialAuth = async (assetId, retryCount = 0) => {
  try {
    const response = await axios.get(socialMedia.checkSocialAuth, {
      params: { assetId },
      timeout: 15000 // 15 seconds timeout
    })
    return response.data.data
  } catch (error) {
    // Check if we should retry
    if (retryCount < 2 && (error.code === 'ECONNABORTED' || !error.response)) {
      // Wait 1 second before retrying
      await new Promise(resolve => setTimeout(resolve, 1000))
      return checkSocialAuth(assetId, retryCount + 1)
    }
    
    console.error('Error in checkSocialAuth action:', error)
    // Return a standard error object
    return { error: true, message: 'Failed to check social authentication' }
  }
}
